import { fetchWithAuth } from '@shared/utils/auth';

export async function fetchForecasterByUrl(url) {
  if (!url) return;
  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении данных Forecasters');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API fetchForecasterTweetsByUrl error:', error);
    throw error;
  }
}